import {
  Box,
  Typography,
  Button,
  Card,
  Grid,
  Tooltip,
  IconButton,
  LinearProgress,
} from "@mui/material";
import {
  fonts,
  headingFonts,
  noOutline,
  primaryButtonStyles,
} from "../../Styles/Styles";
import VerifiedIcon from "@mui/icons-material/Verified";
import FormatTime from "../AdsPage/FormatTime";
import { useNavigate } from "react-router-dom";

// Replace with your actual image imports or URLs
const NewWelcomeCard = ({ user, profileCompletion }) => {
  const navigate = useNavigate();
  return (
    <Grid
      container
      sx={{
        width: "100%",
        borderRadius: 1,
        px: 4,
        py: 3,
        background: "linear-gradient(135deg, #0f172a, #1e293b)",
        color: "white",
      }}
    >
      <Grid item xs={12} md={12}>
        <Typography variant="h6" sx={{ ...fonts, opacity: 0.9 }}>
          Welcome back
        </Typography>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            ...headingFonts,
            display: "flex",
            alignItems: "center",
          }}
        >
          {`${user.firstName} ${user.lastName}`}
          {user.isVerifiedbyID === "approved" && (
            <Tooltip
              title={
                <Typography
                  sx={{
                    ...fonts,
                    fontSize: "14px",
                    color: "white",
                  }}
                >
                  Your identity has been successfully verified through a
                  government ID check.
                </Typography>
              }
              arrow
            >
              <IconButton
                size="small"
                sx={{
                  color: "green",
                  marginLeft: "8px", // Space between name and icon
                  ...noOutline,
                }}
              >
                <VerifiedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Typography>
        <Typography
          variant="body2"
          gutterBottom
          sx={{
            ...fonts,
            display: "flex",
            alignItems: "center",
          }}
        >
          <span sx={{ ...headingFonts }}>Last Active: </span>
          {user?.loginActivity?.length && (
            <FormatTime
              createdAt={
                user.loginActivity[user.loginActivity.length - 1].timestamp
              }
            />
          )}
        </Typography>
        {profileCompletion !== null && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "100%", md: "50%", lg: "50%" }, // Responsive width
            }}
          >
            <Typography
              variant="body2"
              sx={{
                ...headingFonts,
                minWidth: "40px",
              }}
            >
              Profile Completion:
            </Typography>
            <Box sx={{ flexGrow: 1, position: "relative" }}>
              <LinearProgress
                variant="determinate"
                value={profileCompletion}
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: "#e0e0e0",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor:
                      profileCompletion === 100 ? "green" : "orange",
                  },
                }}
              />
            </Box>
            <Typography
              variant="body2"
              sx={{
                ...headingFonts,
                minWidth: "40px",
                textAlign: "right",
                color: profileCompletion === 100 ? "green" : "orange",
              }}
            >
              {profileCompletion}%
            </Typography>
          </Box>
        )}
        {profileCompletion && profileCompletion !== 100 && (
          <Button
            size="small"
            sx={{ mt: 1, ...primaryButtonStyles }}
            onClick={() => navigate("/profile")}
          >
            Complete Profile
          </Button>
        )}
        {profileCompletion && profileCompletion !== 100 && (
          <Box
            sx={{
              backgroundColor: "#fff4e5",
              marginTop: "20px",
              padding: "8px 16px",
              borderTop: "1px solid #f0d6b4",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                ...headingFonts,
                color: "#b75e00",
              }}
            >
              ⚠️ Complete your profile before posting an ad. A complete profile
              is required to post an ad successfully.
            </Typography>
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default NewWelcomeCard;
